import { useEffect, useState } from "react";

import { isPlatformNodeJS } from "./platform.is-node";

export function isTouchDevice(): boolean {
  return "ontouchstart" in window || navigator.maxTouchPoints > 0;
}

/**
 * Allows accessing the platform check through a hook that avoid hydration
 * issues when rendered in Next.JS
 */
export function useIsTouchDevice(options?: { immediate?: boolean }) {
  const [isMatch, setIsMatch] = useState(() =>
    options?.immediate && !isPlatformNodeJS() ? isTouchDevice() : undefined,
  );

  useEffect(() => {
    setIsMatch(isTouchDevice());
  }, []);

  return isMatch;
}
